module.exports = __webpack_public_path__ + "img/p.5a2111c6.jpg";